import $ from 'jquery';
import YouTubePlayer from 'youtube-player';
import Player from '@vimeo/player';

$(function () {
    
    let videoPlayers = [];
    let vimeoPlayers = [];

    $('.youtubevideo .video-in-page').each(function (i, e) {
        $(e).on('click', function (evt) {
            evt.preventDefault();
            let videoWrapperId = $(this).data('video-wrapper');
            if (videoPlayers[i] == null) {
                let w = $(this).outerWidth();
                const $wrapper = $($('#' + videoWrapperId));

                videoPlayers[i] = YouTubePlayer(videoWrapperId, { width: w, height: w * (9 / 16) });
                videoPlayers[i].loadVideoById($wrapper.data('video-id')).then(() => {
                    videoPlayers[i].playVideo();
                });

                videoPlayers[i].on('stateChange', function (state) {
                    if (state.data == 0) {
                        $('#' + videoWrapperId).css('z-index', '-1');
                    }
                });

            } else {
                videoPlayers[i].playVideo();
            }
            $('#' + videoWrapperId).css('z-index', '99');
        });
    });

    $('.vimeovideo .video-in-page').each(function (i, e) {
        $(e).on('click', function (evt) {
            evt.preventDefault();
            let videoWrapperId = $(this).data('video-wrapper');
            if (vimeoPlayers[i] == null) {
                let w = $(this).outerWidth();
                const $wrapper = $($('#' + videoWrapperId));

                vimeoPlayers[i] = new Player(videoWrapperId, { width: w, height: w * (9 / 16), id: $wrapper.data('video-id') });
                vimeoPlayers[i].play();

                vimeoPlayers[i].on('ended', function (state) {
                    $('#' + videoWrapperId).css('z-index', '-1');
                });
            } else {
                vimeoPlayers[i].playVideo();
            }
            $('#' + videoWrapperId).css('z-index', '99');
        });
    });
});